// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__H08ml","title":"BackImages_title__2mSJg","images":"BackImages_images__25Gwq"};